/**
 * 「资料文」检测(2026-08-10 引导批)—— 判断用户贴进文案框的是不是一段产品/业务资料。
 *
 * ═══ 为什么要这个 ═══════════════════════════════════════════════════════════════
 * 400 电话真单实证的用户心智:「我把资料给你了,你看着办」—— 整段贴百科式业务说明
 * (是什么/怎么转接/话费谁出),没有「拍给谁看/要观众做什么」。引擎只能自己编一场戏承载
 * 资料,用户拿到片子的第一反应是「跟我想的完全不符」。
 *
 * 检测到资料文形态时**只提示不拦截**(与「不编排直接出片」的知情确认同一设计哲学):
 * 告诉用户补一句诉求会准很多、资料会自动当素材选用。
 *
 * ═══ 判据(确定性,零 LLM)═════════════════════════════════════════════════════════
 * 同时满足三条才算资料文 —— 宁可漏报不可误报(误报 = 对写对了的用户唠叨):
 *   ① 够长(≥ 80 字):短句子谈不上「资料」;
 *   ② **没有任何诉求信号**(拍给/观众/想让/引导/下单/咨询…):有一个就说明用户在提需求;
 *   ③ **至少一个说明文标志**(是指/又称/简称/是由…组成/专为…设计/旨在…):
 *      纯叙述长文不一定是资料,带百科句式才是。
 */

/** 诉求信号:文案里出现任何一个 = 用户在提拍摄需求,不是纯资料。与底稿三槽模板的用词同源。 */
const INTENT_MARKERS =
  /拍给|观众|想让|引导|号召|下单|购买|咨询|预约|留资|涨粉|关注|转化|私信|进店|报名|投递|开通|办理|主打|卖点|钩子|镜头|分镜|旁白|口播/;
// ★不收「开头/结尾」:太泛 ——「"400"开头组成的号码」这类资料句会误伤(真单原文实测),
//   拍摄语境已有 钩子/镜头/分镜 等信号兜着。

/** 说明文标志:百科/官网介绍的惯用句式。 */
const ENCYCLOPEDIA_MARKERS = [
  /是指/,
  /又称/,
  /简称/,
  /所谓/,
  /是一种/,
  /是由.{0,16}(组成|提供|推出|设计)/,
  /专为.{0,24}(设计|打造|推出)/,
  /旨在/,
  /指的是/,
  /广泛(应用|用于)/,
  /具有.{0,16}(功能|特点|优势)[,。;]/,
];

const MIN_MATERIAL_LENGTH = 80;

/** 用户文案是否像一段纯资料(说明文)而不是拍摄诉求。 */
export function looksLikeMaterialDoc(text: string | null | undefined): boolean {
  const t = (text ?? "").trim();
  if (t.length < MIN_MATERIAL_LENGTH) return false;
  if (INTENT_MARKERS.test(t)) return false;
  return ENCYCLOPEDIA_MARKERS.some((p) => p.test(t));
}

/** 提示文案单点(创建页横幅用;措辞不拦人,给出补法)。 */
export const MATERIAL_DOC_HINT =
  "这段更像产品/业务资料 —— 补一句「拍给谁看、想让观众做什么」,片子会准很多;资料会自动当素材选用。";
